import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// React Strict Mode intentionally double-executes effects in development
// to help detect side effects. Our hooks now handle this properly.
// If you still see duplicate requests in development, use main.dev.jsx instead.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)